import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/facebook.png'
import _imports_1 from '../assets/whatsapp.png'
import _imports_2 from '../assets/Instagram.png'


const _hoisted_1 = { class: "floating-contact-buttons" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["alt"]

import { useI18n } from 'vue-i18n';

// 使用i18n获取翻译文本

export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingContactButtons',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "https://www.facebook.com/profile.php?id=61577205355724",
      target: "_blank",
      class: "floating-button facebook-button",
      title: _unref(t)('facebook')
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _unref(t)('facebook'),
        class: "button-icon"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("a", {
      href: "whatsapp://send?phone=+85266860815",
      target: "_blank",
      class: "floating-button whatsapp-button",
      title: _unref(t)('whatsapp')
    }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: _unref(t)('whatsapp'),
        class: "button-icon"
      }, null, 8, _hoisted_5)
    ], 8, _hoisted_4),
    _createElementVNode("a", {
      href: "https://www.instagram.com/dr_moto_ev_hk_ltd/",
      target: "_blank",
      class: "floating-button instagram-button",
      title: _unref(t)('instagram')
    }, [
      _createElementVNode("img", {
        src: _imports_2,
        alt: _unref(t)('instagram'),
        class: "button-icon"
      }, null, 8, _hoisted_7)
    ], 8, _hoisted_6)
  ]))
}
}

})